/**
 * i18n — Initialise i18next with English (default) and Chinese
 *
 * Import this module once in main.tsx before React renders.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';
import zh from './zh';
import zhHant from './zh-Hant';
import ms from './ms';
import id from './id';
import ja from './ja';
import th from './th';
import vi from './vi';

const savedLang = typeof localStorage !== 'undefined'
  ? (localStorage.getItem('boox_lang') ?? 'en')
  : 'en';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
    'zh-Hant': { translation: zhHant },
    id: { translation: id },
    ms: { translation: ms },
    ja: { translation: ja },
    th: { translation: th },
    vi: { translation: vi },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  initImmediate: false, // synchronous init — prevents useTranslation warning
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = savedLang;
}

/** Persist language choice */
i18n.on('languageChanged', (lng) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('boox_lang', lng);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

export default i18n;

// Re-export react-i18next hooks so go-pwa/extension-shell can use i18n
// without declaring react-i18next as a direct dependency.
export { useTranslation } from 'react-i18next';
